import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

type ResultType = {
    title: string;
    description: string;
};
type ResultsPropsType = {
    list: ResultType[];
};
const Results = ({ list }: ResultsPropsType) => {
    return (
        <div className="ck10-results">
            <FullWrapper isMargin={false}>
                <div className="ck10-resultsInner">
                    <div className="ck10-resultsLeft">
                        <div className="ck10-resultsTitle">Результаты</div>
                        <div className="ck10-resultsParagraf">
                            Команде &laquo;Вебпрактик&raquo; удалось в&nbsp;3&nbsp;раза увеличить
                            объём лидов на&nbsp;покупку квартир и&nbsp;получить 4&nbsp;600+
                            качественных лидов.
                        </div>
                        <div className="ck10-resultsParagraf">
                            Комбинация различных рекламных каналов и&nbsp;форматов
                            с&nbsp;подключением медийной рекламы для наращивания охватов позволила
                            в&nbsp;5&nbsp;раза снизить цену качественного лида по&nbsp;сравнению
                            с&nbsp;прошлыми рекламными запусками клиента.
                        </div>
                        <div className="ck10-resultsList">
                            {list &&
                                list.map(({ title, description }) => (
                                    <div className="ck10-resultsItem" key={title}>
                                        <div
                                            className="ck10-resultsText"
                                            dangerouslySetInnerHTML={{ __html: title }}
                                        ></div>
                                        <div
                                            className="ck10-resultsDescription"
                                            dangerouslySetInnerHTML={{ __html: description }}
                                        ></div>
                                    </div>
                                ))}
                        </div>
                        <div className="ck10-resultsParagraf">
                            Партнерство с&nbsp;клиентом продолжаем. Сейчас в&nbsp;работе
                            90&nbsp;активных кампаний по&nbsp;5&nbsp;ЖК. Компания СК10 стабильно
                            получает заявки, которые конвертируются в&nbsp;закрытые сделки.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Results;
